"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _reactDom = require("react-dom");

var _exenv = require("exenv");

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Portal =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Portal, _Component);

  function Portal(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "node", void 0);

    if (_exenv.canUseDOM) {
      _this.node = document.createElement('div');
    }

    return _this;
  }

  var _proto = Portal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    _exenv.canUseDOM && document.body && this.node && document.body.appendChild(this.node);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    _exenv.canUseDOM && document.body && this.node && document.body.removeChild(this.node);
  };

  _proto.render = function render() {
    return _exenv.canUseDOM && this.node ? (0, _reactDom.createPortal)(this.props.children, this.node) : null;
  };

  return Portal;
}(_react.Component);

exports.default = Portal;

_defineProperty(Portal, "displayName", 'Portal');